// @flow

import type {ApplicationState} from '../../types'
import type {MapState} from '../types'

export function getSelectedCity(appState: ApplicationState): ?Url{
  return _getSelectedCity(appState.map) 
}

function _getSelectedCity(state: MapState): ?Url{
  return state.selectedCity
}

getSelectedCity.internal = _getSelectedCity
